import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[baasViewContainerRef]'
})
export class BaasViewContainerRef {
    readonly viewContainerRef = inject(ViewContainerRef);
}
